import React from "react";
import "./WelcomePage.css";
import NavBar from "../NavBar/NavBar";
import LeftSide from "../LeftSide/LeftSide";
import Center from "../Center/Center";
import RightSide from "../RightSide/RightSide";
import "../lib/RequireUser/index.css";
import { reload } from "firebase/auth";
//import { UserStatus } from "../UserStatus/UserStatus";
//import { auth } from "../../Lib/firebase";

function reloadFromError() {
  if (localStorage.getItem("welcomeRefresh") === "No") {
    window.location.reload();
    localStorage.setItem("welcomeRefresh", "Yes");
  }
}

//let user = UserStatus();
//console.log("In WelcomePage after Userstatus and user = " + user);

function WelcomePage() {
  //console.log("In WelcomePage before status and user = " + user);
  //console.log("In WelcomePage before status and user = " + user);

  //var user = auth.currentUser;
  //console.log("In WelcomePage after status and user = " + user);
  //console.log("In WelcomePage after status and user = " + user);
  //if (user === undefined || user === null) {
  //  console.log("In WelcomePage if and user = null " + user);
  //  window.location.assign("../");
  var bodyStyles = document.body.style;
  //const userUID = bodyStyles.getPropertyValue("--user");
  //console.log("inside welcome and user id from root = ", userUID);
  setTimeout(reloadFromError, 1000);
  return (
    <>
      <div className="welcome-container"></div>
      <nav>
        <NavBar />
      </nav>
      <nav className="welcome-main">
        <div className="leftside">
          <LeftSide />
        </div>
        <div className="center">
          <Center />
        </div>
        <div className="rightside">
          <RightSide />
        </div>
      </nav>
    </>
  );
}

export default WelcomePage;
